// LoadingPlaceholder.tsx
import React from 'react';
import { Spin } from 'antd';
import './LoadingPlaceholder.less';

interface LoadingPlaceholderProps {
  message?: string;
}

const LoadingPlaceholder: React.FC<LoadingPlaceholderProps> = ({ message = "加载中，请稍候..." }) => {
  return (
    <div className="loading-wrapper">
      <Spin size="large" className="custom-spin" />
      <div className="loading-text">{message}</div>
    </div>
  );
};

export default LoadingPlaceholder;